import type { ButtonHTMLAttributes } from 'react'

import styles from './button.module.scss'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'ghost'
  /** Stretch to the full width of the parent. */
  block?: boolean
}

export default function Button({
  variant = 'primary',
  block = false,
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  const cls = [styles.btn, styles[variant], block && styles.block, className]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      type={type}
      className={cls}
      {...rest}
    />
  )
}
